import { Box, CardBody, CardFooter, CardHeader, Checkbox, FormControl, FormErrorMessage, FormLabel, Input, Textarea, VStack } from "@chakra-ui/react";
import { memo, useEffect, useState } from "react"
import { SubmitBtn } from "../../atoms/button/SubmitBtn";
import { RankCheckbox } from "./RankCheckbox";
import { DarkShadowCard } from "../../molecules/card/DarkShadowCard";
import { CardHeading } from "../../molecules/card/CardHeading";
import { IoDiamondSharp } from "react-icons/io5";


type SoCouponFormProps = {
  img?: string;
  handleSubmit: any;
  register: any;
  control: any;
  isSubmitting: boolean;
  errors: any;
  setValue: any;
}
export const BenefitForm: React.FC<SoCouponFormProps> = memo(({img, handleSubmit, register, isSubmitting, errors, setValue, control}) => {
  return (
    <Box m='auto' w={{base: '100%', md: '580px'}}>
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <DarkShadowCard>
          <CardHeader>
            <CardHeading icon={<IoDiamondSharp size="20px" fontSize='sm' />} heading='特典'/>
          </CardHeader>
          <CardBody py={2}>
            <VStack spacing={4}>
              <ImgInput img={img} register={register} setValue={setValue} />
              <RankCheckbox control={control} errors={errors} />
              <TitleInput register={register} errors={errors} />
              <ExplanationInput register={register} errors={errors} />
              <NotesInput register={register} errors={errors} />
            </VStack>
          </CardBody>
          <CardFooter>
            <SubmitBtn isLoading={isSubmitting}>登録</SubmitBtn>
          </CardFooter>
        </DarkShadowCard>
      </form>
    </Box>
  );
});


type ImgInputProps = {
  img?: string;
  register: any;
  setValue: any;
}
const ImgInput: React.FC<ImgInputProps> = memo(({img, register, setValue}) => {
  const [useDefaultImg, setUseDefaultImg] = useState<boolean>(img ? false : true);
  useEffect(() => {
    if (useDefaultImg) setValue('img', 'default');
  }, [useDefaultImg]);
  useEffect(() => {
    setUseDefaultImg(img ? false : true)
  }, [img]);
  return (
    <FormControl>
      <FormLabel>特典画像</FormLabel>
      <VStack align='start' spacing={1}>
        <input type="file" accept="image/*" {...register('img')} disabled={useDefaultImg}  />
        <Checkbox isChecked={useDefaultImg} onChange={() => setUseDefaultImg(!useDefaultImg)} size='sm' m='0'>デフォルト画像を使用</Checkbox>
      </VStack>
    </FormControl>
  )
})


const TitleInput: React.FC<{register: any, errors: any}> = memo(({register, errors}) => {
  return (
    <FormControl isRequired>
      <FormLabel>タイトル</FormLabel>
      <Input {...register('title')} />
      <FormErrorMessage>{errors.title?.message}</FormErrorMessage>
    </FormControl>
  )
})
const ExplanationInput: React.FC<{register: any, errors: any}> = memo(({register, errors}) => {
  return (
    <FormControl isRequired>
      <FormLabel>概要</FormLabel>
      <Textarea {...register('explanation')} />
      <FormErrorMessage>{errors.explanation?.message}</FormErrorMessage>
    </FormControl>
  )
})
const NotesInput: React.FC<{register: any, errors: any}> = memo(({register, errors}) => {
  return (
    <FormControl isRequired>
      <FormLabel>注意事項</FormLabel>
      <Textarea {...register('notes')} />
      <FormErrorMessage>{errors.notes?.message}</FormErrorMessage>
    </FormControl>
  )
})
